class BlogPagination extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.loadMoreItems);
  }

  loadMoreItems() {
    const urlFetch = this.dataset.href;

    fetch(urlFetch)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = new DOMParser().parseFromString(state, 'text/html');
        const getLinkNextPage = parsedState.querySelector('.blog-articles__load-more');

        document.querySelector('.blog-articles').innerHTML += parsedState.querySelector('.blog-articles').innerHTML;
        this.closest('.blog-articles__load-more').innerHTML = getLinkNextPage.innerHTML;
      });
  }
}
customElements.define('blog-pagination', BlogPagination);
